import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-942f8162"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-panel" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Caret = _resolveComponent("Caret")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-panel", { 'rounded-border': _ctx.isCollapsed }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onHeaderClicked()))
    }, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Caret, {
        color: "#b29475",
        width: "30",
        height: "30",
        isCollapsed: _ctx.isCollapsed
      }, null, 8, ["isCollapsed"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { hidden: _ctx.isCollapsed }])
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.content), 1)
    ], 2)
  ]))
}